import { Row, Col, Container } from "react-bootstrap";
import OwnerShopProfile from "../../components/OwnerShopProfile/OwnerShopProfile";
import ShopItemsOwner from "../../components/ShopItemsOwner/ShopItems";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import {
  useGetShopByIdQuery,
  useGetUserShopsByBusinessTypeQuery,
  useLazyGetShopSuggestionsByVendorIdQuery,
} from "../../features/shop/shopApiSlice";
import { useSelector } from "react-redux";
import { extractIdFromSlug } from "../../utils/slugUtils";
import BackArrow from "../../components/backArrow";
import ShopManagebuttons from "../../components/Shops_manage_buttons";

const RecycleOwnerProfile = () => {
  const { id: slugId } = useParams();
  const id = extractIdFromSlug(slugId);
  const [shopData, setShopData] = useState();
  const [suggest, setSuggest] = useState(0);
  const [suggestdata, setSuggestdata] = useState();
  const [suggestdetail, setSuggestdetail] = useState(0);
  const { name } = useSelector((state) => state.user);
  const { data: userShopsData } = useGetUserShopsByBusinessTypeQuery(
    { userid: name?._id, businessType: "recycledShop" },
    { skip: !name?._id }
  );

  useEffect(() => {
    if (userShopsData?.success) {
      const shopCategoryName = userShopsData?.data?.Shops?.[0]?.shopCategory?.name;
      if (shopCategoryName) {
        localStorage.setItem("mycategory", shopCategoryName);
      }
    }
  }, [userShopsData]);

  const { data: shopQueryData } = useGetShopByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (shopQueryData?.success) {
      setShopData(shopQueryData?.data?.Shop);
    }
  }, [shopQueryData]);

  const [getSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  const suggestdatta = async () => {
    if (shopData?._id) {
      try {
        const response = await getSuggestions(shopData._id).unwrap();
        const allSuggestions = response?.data?.reduce((acc, curr) => {
          return [...acc, ...(curr?.suggestions || [])];
        }, []) || [];
        setSuggestdata(allSuggestions);
      } catch (error) {
        console.error("Failed to fetch suggestions:", error);
      }
    }
  };
  return (
    <Container>
      <Col md={11} lg={11} className="mx-auto ">
        <Row>
          <Col md={4} lg={3} className="p-0">
            {" "}
            <OwnerShopProfile
              shopid={id}
              salespromotion="sales promotion"
              icon={<LocalOfferIcon className="silver-icon" />}
              Name="Update Recycle Profile"
              navigateTo="/recycle-update"
              post="/recycle-postadd"
              myid={id}
              shopData={shopData}
              setSuggest={setSuggest}
              suggestdatta={suggestdatta}
            />
          </Col>
          <Col md={8} lg={9} className=" screenHeight custom_ps-4">
            <div className="Form-Shadow h-100">
              <Row>
                <Col lg="4">
                  <BackArrow
                    back={`/rawmaterial-recycle/${id}`}
                    mystyle="d-none d-lg-block"
                  />
                </Col>
                <Col lg="8" className="mt-2 pe-4">
                  <ShopManagebuttons businessurl="/recycle-shops" shopid={id} />
                </Col>
              </Row>
              <ShopItemsOwner
                urlPass="/recycle-item-owner-view"
                navigateto="/recycle-shop"
                shopData={shopData}
                shopid={id}
                suggest={suggest}
                setSuggest={setSuggest}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
                post={`/recycle-postadd/${id}`}
                suggestdata={suggestdata}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default RecycleOwnerProfile;
